import React from 'react';
import styled from 'styled-components';
import { string, func } from 'prop-types';

const Container = styled.div`
  width: 288px;
  height: 204px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 24px;
  margin: 12px;
`;

const Image = styled.img`
  width: 64px;
  height: 64px;
`;

const Text = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 20px;
  line-height: 1.4;
  text-align: center;
  margin-bottom: 8px;
  color: #4a4a4a;
  font-weight: 600;
`;

const Button = styled.a`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  line-height: 1.43;
  border-radius: 1000px;
  border: solid 1px #f28000;
  background-color: #fff;
  padding: 6px 20px;
  color: #f28000;
  cursor: pointer;
`;

const Card = ({
  icon, text, button, href, handleClick, posName, type,
}) => (
  <Container>
    <Image src={`${process.env.PUBLIC_URL}/images/${icon}.svg`} alt={text} />
    <Text>{text}</Text>
    <Button onClick={() => handleClick(posName, type)} href={href}>{button}</Button>
  </Container>
);

Card.propTypes = {
  icon: string.isRequired,
  text: string.isRequired,
  button: string.isRequired,
  handleClick: func.isRequired,
  type: string.isRequired,
  posName: string.isRequired,
  href: string,
};

Card.defaultProps = {
  href: '',
};

export default Card;
